export default "https://api.uport.space/chasqui/";
